<template>
  <default-modal ref="box" :title="title" :confirmBtn="false">
    <div class="modal-body">
      <div class="row">
        <span class="left">任务文件：</span>
        <div style="float:left;">
          <Select
            v-model="taskFileId"
            clearable
            filterable
            disabled
            placeholder="请选择文件"
            style="width:300px;display:inline-block"
          >
            <Option
              v-for="(item, index) in fileList"
              :value="item.fileId"
              :key="index"
              :label="
                item.remark
                  ? item.fileName + '(' + item.remark + ')'
                  : item.fileName
              "
            >
              <span v-text="item.fileName"></span>
              <div v-show="item.remark" style="display:inline-block">
                (<span v-text="item.remark"></span>)
              </div>
            </Option>
          </Select>
          <Button
            disabled
            icon="ios-cloud-upload-outline"
            style="display:inline-block;margin:-8px 0 10px 10px"
            type="default"
            >上传文件</Button
          >
          <!-- <file-upload
            ref="fileUpload"
            :format="[
              'exe',
              'bat',
              'ps1',
              'rar',
              'zip',
              '7z',
              'reg',
              'txt',
              'dll',
              'ini',
              'cfg',
              'doc',
              'docx',
              'xls',
              'xlsx',
              'jpg',
              'gif',
              'png',
              'bmp',
              'vbs',
            ]"
            :url="$HTTP_API.threeTierMission.uploadFile"
            :size="32768"
            @fileResult="fileResult"
            style="display:inline-block;margin:0 0 10px 10px"
          ></file-upload> -->
          <div>
            <input
              class="com"
              type="text"
              v-model="fileUrl"
              placeholder="仅支持HTTP或HTTPS下载地址，不支持FTP"
              disabled
            />
            <input
              type="checkbox"
              v-model="customize"
              class="checkbox customize"
              disabled
            />
            自定义下载链接
          </div>
        </div>
      </div>
      <div class="row">
        <span class="left">任务名称：</span>
        <input
          class="com"
          type="text"
          v-model="taskName"
          disabled
          placeholder="默认读取文件名可修改"
        />
      </div>
      <div class="row">
        <span class="left">执行方式：</span>
        <Select disabled v-model="runType" style="width:150px">
          <Option
            v-for="(item, index) in runTypeList"
            :value="item.ruleId"
            :key="index"
            >{{ item.ruleName }}</Option
          >
        </Select>
        <Input
          :value="time"
          class="way"
          disabled
          style="vertical-align:text-bottom;"
          v-show="taskType == 0 && runType == 3"
        />
        <div v-show="taskType == 0 && runType == 3">
          <Select
            v-model="weekIdList"
            multiple
            disabled
            style="width:400px;margin:10px 5px 0 90px;"
          >
            <Option
              v-for="(item, index) in weekList"
              :value="item.value"
              :key="index"
              >{{ item.label }}</Option
            >
          </Select>
          <div style="display: inline-block;position: relative;top: 3px;">
            <input
              disabled
              type="checkbox"
              v-model="bRepeat"
              class="checkbox"
            />
            重复执行
          </div>
        </div>
        <span
          v-show="taskType == 1 && runType == 2"
          style="margin-left:5px;vertical-align:super;"
          >该方式仅向当前在线的客户机推送并执行一次</span
        >
      </div>
      <div class="row" v-show="taskType == 1">
        <span class="left"></span>
        <input type="checkbox" disabled v-model="superRun" class="checkbox" />
        无盘超管状态不执行
      </div>
      <div class="row dropDown">
        <div class="border" style="width:50px;"></div>
        <div @click.prevent="showDrop = !showDrop">
          <span>高级设置</span>
          <img src="@/assets/img/icon/u2898.svg" alt="" v-show="showDrop" />
          <img
            src="@/assets/img/icon/u2898.svg"
            alt=""
            style="transform: rotate(180deg);"
            v-show="!showDrop"
          />
        </div>
        <div class="border" style="min-width:400px;"></div>
      </div>
      <div v-show="showDrop">
        <div class="row">
          <span class="left">存储位置：</span>
          <input
            class="com"
            type="text"
            disabled
            v-model="localFilePath"
            placeholder="默认设置路径"
          />
        </div>
        <div class="row" style="margin:0;height: 16px;">
          <span class="left"></span>
          <span v-show="taskType == 0"
            >默认设置路径：维护大师服务端目录下的“wzServerTaskPkg”</span
          >
          <span v-show="taskType == 1"
            >默认设置路径：维护大师客户端目录下的“wzClientTaskPkg”</span
          >
        </div>
        <div class="row">
          <span class="left">参数执行：</span>
          <textarea
            v-model="param"
            disabled
            name=""
            id=""
            cols="10"
            rows="2"
            placeholder="输入参数（选填）"
          ></textarea>
        </div>
        <div class="row" style="margin:0;">
          <span class="left">其他设置：</span>
          <div style="float:left;line-height:30px;">
            <input
              disabled
              type="checkbox"
              v-model="bHideWindow"
              class="checkbox"
            />
            隐藏窗口执行
          </div>
        </div>
        <div class="row" style="margin:0;height: 16px;">
          <span class="left"></span>
          <span class="tips"
            >注意：当系统没有用户登录时，程序在任何时候都会隐藏窗口执行。</span
          >
        </div>
      </div>
    </div>
  </default-modal>
</template>
<script>
import DefaultModal from '_c/modals/defaultModal'
export default {
  components: {
    DefaultModal,
  },
  data() {
    return {
      fileUrl: '',
      fileList: [],
      runTypeList: [],
      taskFileId: '',
      customize: false,
      taskName: '',
      runType: 0,
      localFilePath: '',
      weekIdList: [],
      weekList: [
        {
          value: 1,
          label: '周一',
        },
        {
          value: 2,
          label: '周二',
        },
        {
          value: 4,
          label: '周三',
        },
        {
          value: 8,
          label: '周四',
        },
        {
          value: 16,
          label: '周五',
        },
        {
          value: 32,
          label: '周六',
        },
        {
          value: 64,
          label: '周日',
        },
      ],
      nWeekDaylist: 0,
      param: '',
      bHideWindow: false,
      time: '',
      beginHour: '',
      beginMinute: '',
      bRepeat: false,
      superRun: false,
      taskType: 0,
      title: '',
      config: {
        noCalendar: true,
        dateFormat: 'H:i', //data变成时间戳
        altFormat: 'H:i', //选择时显示的时间
        enableTime: true, //选择小时分种
        defaultHour: 8, //默认8点
        time_24hr: true, //时间24小时制
      },
      confirmText: '创建',
      successFn: '',
      showDrop: true,
    }
  },
  watch: {
    customize() {
      if (this.customize) {
        this.taskFileId = ''
      }
    },
    fileUrl() {
      this.getFileName(this.fileUrl)
    },
    taskFileId() {
      for (let item of this.fileList) {
        if (this.taskFileId == item.fileId) {
          this.taskName = item.fileName
        }
      }
    },
  },
  mounted() {
    window.$modal.showTaskModal = {}
    window.$modal.showTaskModal.show = (val, item) => {
      this.taskType = val
      if (val == 0) {
        this.title = '服务器任务'
      } else {
        this.title = '客户机任务'
      }
      return new Promise((resolve) => {
        this.init(() => {
          resolve(true)
        }, item)
      })
    }
    //监听键盘按键事件
    let self = this
    this.$nextTick(function() {
      document.addEventListener('keyup', function(e) {
        //此处填写你的业务逻辑即可
        if (e.keyCode == 27) {
          self.$refs.box.hide()
        }
      })
    })
  },
  methods: {
    getFileName(val) {
      let pos = val.lastIndexOf('\/')
      let pos2 = val.lastIndexOf('.')
      //strFileName=str.substring(pos+1);//文件名带后缀
      this.taskName = val.substring(pos + 1, pos2) //文件名不带后缀
    },
    // 初始化信息
    init(fn, data) {
      console.log(data)
      this.$refs.box.show()
      this.taskFileId = ''
      this.fileUrl = ''
      this.taskName = ''
      this.runType = 0
      this.weekIdList = []
      this.localFilePath = ''
      this.param = ''
      this.bHideWindow = false
      this.time = ''
      this.bRepeat = false
      this.superRun = false
      if (data.url) {
        this.customize = true
        this.fileUrl = data.url
      } else {
        this.taskFileId = data.fileId
      }
      this.taskName = data.taskName
      this.localFilePath = data.localFilePath
      this.superRun = data.superRun
      this.bHideWindow = data.bhideWindow
      this.param = data.param
      this.runType = data.runType
      this.time =
        '' +
        (data.beginHour > 10 ? data.beginHour : 0 + '' + data.beginHour) +
        ':' +
        (data.beginMinute > 10 ? data.beginMinute : '0' + data.beginMinute)
      this.bRepeat = data.brepeat
      let nWeekDaylist = data.nweekDaylist
      nWeekDaylist = nWeekDaylist.toString(2)
      let arr = nWeekDaylist.split('')
      for (let i = 0; i < arr.length; i++) {
        let num = Number(arr[i])
        if (num === 1) {
          this.weekIdList.push(Math.pow(2, arr.length - 1 - i))
        }
      }
      this.weekIdList.sort()
      this.fileList = [
        {
          fileId: data.fileId,
          fileName: data.fileName,
        },
      ]
      this.getRuleType()
      this.successFn = fn
    },
    async getRuleType() {
      if (this.taskType == 0) {
        this.runTypeList = [
          {
            ruleId: 2,
            ruleName: '下载后执行一次',
          },
          {
            ruleId: 1,
            ruleName: '仅下载不执行',
          },
          {
            ruleId: 3,
            ruleName: '定时执行',
          },
        ]
      } else {
        this.runTypeList = [
          {
            ruleId: 1,
            ruleName: '仅下载不执行',
          },
          {
            ruleId: 4,
            ruleName: '开机执行',
          },
          {
            ruleId: 2,
            ruleName: '立即执行',
          },
        ]
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.modal-body {
  padding: 10px;
  text-align: left;
  position: relative;
  .row {
    overflow: hidden;
    margin: 10px 0;
    .left {
      float: left;
      margin-right: 10px;
      min-width: 80px;
      display: inline-block;
      text-align: right;
      height: 30px;
      line-height: 30px;
    }
  }
  select {
    width: 200px;
  }
  input.com {
    width: 300px;
    height: 30px;
    border: 1px solid rgba(215, 215, 215, 1);
    font-size: 12px;
    color: #515151;
    text-align: left;
    padding-left: 10px;
  }
  .way {
    width: 70px;
    margin: 0px 5px;
    border: 1px solid rgb(215, 215, 215);
    height: 32px;
    border-radius: 3px;
    padding-left: 5px;
    display: inline-block;
  }
  .checkbox {
    position: relative;
    top: 2px;
  }
  .customize {
    margin-left: 10px;
  }
  textarea {
    padding: 9px;
    width: 400px;
    height: 50px;
    white-space: nowrap;
    overflow: auto;
    border: 1px solid rgba(215, 215, 215, 1);
  }
  .dropDown {
    color: rgb(0, 153, 204);
    padding-left: 22px;
    div {
      display: inline-block;
      cursor: pointer;
    }
    .border {
      border-bottom: 1px solid rgba(215, 215, 215, 1);
      margin-bottom: 2px;
    }
    img {
      margin: 0 10px 0 8px;
    }
    span {
      margin-left: 10px;
    }
  }
  .tips {
    color: rgb(217, 0, 27);
    font-size: 12px;
  }
}
.ivu-select {
  vertical-align: text-bottom;
}
</style>
